import { CheckoutState, ServerLine, Group, Subgroup, Option, Agreement } from './../checkout/checkout.reducer';
import { Component } from '@angular/core';
import { ApiService } from '../services/api.service';
import { BreadcrumbsService } from '../services/breadcrumbs.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckoutService } from '../services/checkout.service';
import { LocalStorageService } from '../services/local-storage.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-service-offer-details',
  templateUrl: './service-offer-details.component.html',
  styleUrls: ['../../assets/css/bootstrap.min.css', '../../assets/sass/checkout.scss']
})
export class ServiceOfferDetailsComponent {
  checkout: CheckoutState;
  serviceUUID: String;

  constructor(
    private notificationService: NotificationsService,
    private apiService: ApiService,
    private breadcrumbsService: BreadcrumbsService,
    private route: ActivatedRoute,
    private checkoutService: CheckoutService,
    private localStorageService: LocalStorageService,
    private router: Router,
  ) {
    this.route.params.subscribe(params => {
      this.serviceUUID = String(params['id']);
      this.breadcrumbsService.translateBreadcrumb(
        `/service/offer/${this.serviceUUID}`, 'Trwa ładowanie usługi');
      this.apiService.get(`/offer/services/${this.serviceUUID}`).subscribe(response => {
        this.checkout = { line: this.parseLine(response.product), id: this.serviceUUID };
        this.checkoutService.setCheckout(this.checkout);
        this.parseInitData(this.checkout);
        this.breadcrumbsService.translateBreadcrumb(
          `/checkout/select/${this.serviceUUID}`,
          this.checkout.line.name
        );
      }, error => {
        if (error.status.code === 404) {
          this.router.navigateByUrl('/checkout/select');
          notificationService.error('Brak linii serwerowej', 'Wybrany linia serwerowa nie jest aktualnie dostępna w sprzedaży');
          return;
        }
      });
    });
  }

  goToCompanySelect() {
    this.checkoutService.setCheckout(this.checkout);
    this.router.navigateByUrl('/checkout/company');
  }

  parseInitData(rawData: CheckoutState) {
    const product = this.checkoutService.getSelectedProduct();
    rawData.line.groups.forEach(group => {
      group.subgroups.forEach(subgrup => {
        if (product) {
          const foundOptionToCheck = subgrup.options.filter(o => product.positions.filter(pos => pos.id === o.id).length).length !== 0;
          if (subgrup.type === 'radio' && foundOptionToCheck) {
            subgrup.options.map(o =>
              Object.assign(o, { checked: false })
            );
          }

          subgrup.options.forEach(option => {
            const index = product.positions.findIndex(pos => pos.id === option.id);
            if (index > -1) {
              option.checked = true;
              option.selectedValue = product.positions[index].count || option.selectedValue;
            }
          });
        }
        if (subgrup.type === 'radio' && subgrup.options.filter(o => o.checked).length === 0) {
          // subgrup.options[0].checked = true;
        }
      });
    });
  }

  private parseLine(line): ServerLine {
    const agreements = this.selectAgreementsPerLineType(line.type);
    return {
      name: line.name,
      type: line.type,
      netto: Number.parseInt(line.netto),
      groups: this.parseGroups(line.groups),
      agreements: agreements
    };
  };

  private selectAgreementsPerLineType(lineType): Array<Agreement> {
    if (lineType === 'application') {
      return [
        {
          name: '24 miesiące',
          value: 24,
          checked: false
        },
        {
          name: '36 miesięcy',
          value: 36,
          checked: true
        },
        {
          name: 'Potrzebujesz innego czasu trwania umowy?<br> Zadzwoń do nas pod nr <a href="tel:+48566577179">56 657 71 79</a> lub napisz na <a href="mailto:sales@dataspace.pl">sales@dataspace.pl</a>',
          value: -1,
          checked: false,
        }
      ];
    }
    return [
      {
        name: '12 miesięcy',
        value: 12,
        checked: false
      },
      {
        name: '24 miesiące',
        value: 24,
        checked: true
      },
      {
        name: 'Czas nieokreślony',
        value: -1,
        checked: false
      }
    ];
  }

  private parseGroups(groups): Group[] {
    const groupList = [];

    for (const groupId in groups) {
      if (groups.hasOwnProperty(groupId)) {
        const group = groups[groupId];
        groupList.push({
          name: group.groupName,
          type: group.groupType,
          subgroups: this.parseSubgroups(group.subgroups)
        });
      }
    }
    return groupList;
  }

  private parseSubgroups(subgroups): Subgroup[] {
    const mappedType = {
      single: 'radio',
      multi: 'checkbox',
    };

    const subgroupList = [];

    subgroups.forEach(element => {
      subgroupList.push({
        name: element.name,
        label: element.label,
        description: element.hasOwnProperty('description') ? element.description : false,
        type: mappedType[element.valueType],
        order: element.ordinal_number || false,
        options: this.parseOptions(element.values),
      });
    });

    return subgroupList;
  }

  private parseOptions(positions): Option[] {
    const optionList = [];

    positions.forEach(element => {
      const type = element.hasOwnProperty('min') ? (element.hasOwnProperty('max') ? 'single' : 'multi') : 'none';
      let option = {};
      switch (type) {
        case 'multi': option = this.parseSelectOption(element); break;
        case 'single': option = this.parseRangeOption(element); break;
        default: option = this.parseNormalOption(element); break;
      }
      optionList.push(option);
    });

    return optionList;
  }

  private parseSelectOption(option) {
    let range = {};

    option.min.forEach((element, index) => {
      range[element] = Number.parseInt(option.netto[index] || option.netto[index] === 0 ? option.netto[index] : option.netto[0]);
    });

    return {
      order: option.ordinal_number,
      id: option.position_id,
      netto: Number.parseInt(option.netto),
      value: option.value,
      unit: option.unit,
      type: 'select',
      range: range,
      service: option.service_id,
      description: option.description,
      checked: option.default || false,
      selectedValue: range[Object.keys(range)[0]],
    };
  }

  private parseRangeOption(option) {
    const max = Number.parseInt(option.max),
      min = Number.parseInt(option.min),
      count = Number.parseInt(option.count);
    return {
      order: option.ordinal_number,
      id: option.position_id,
      netto: Number.parseInt(option.netto),
      value: option.value,
      unit: option.unit,
      type: 'range',
      min: min,
      max: max,
      service: option.service_id,
      description: option.description,
      checked: option.default || false,
      selectedValue: count >= min && count <= max ? count : min,
    };
  }

  private parseNormalOption(option) {
    const max = Number.parseInt(option.max),
      min = Number.parseInt(option.min),
      count = Number.parseInt(option.count);
    return {
      order: option.ordinal_number,
      id: option.position_id,
      netto: Number.parseInt(option.netto),
      value: option.value,
      unit: option.unit,
      type: 'none',
      description: option.description,
      checked: option.default || false,
      selectedValue: count >= min && count <= max ? count : min,
    };
  }

  onAgreementChange(agreement) {
    this.checkout.line.agreements.forEach(agreement => {
      agreement.checked = false;
    });
    agreement.checked = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/service/service-offer-details.component.ts